<!-- eslint-disable vue/attribute-hyphenation -->
<template>
  <div
    class="w-full h-full overflow-hidden print:overflow-auto"
    v-if="this.$store.state.TEAMS.teams.length != 0"
  >
    <div class="flex flex-col w-full h-full">
      <select-report-type-menu
        :show-test-btn="true"
        :show-questionnaire-btn="showQuestionnaireBtn"
        :questionnaireId="(showQuestionnaireBtn) ?currentTeam.QuestionnaireBatteries[0].id : '' "
      />
    </div>
  </div>
</template>

<script>
import SelectReportTypeMenu from '../components/SelectReportTypeMenu.vue'
import { mapGetters, mapActions } from 'vuex'

export default {
  components: {
    SelectReportTypeMenu
  },
  props: {
    campaignId: {
      type: String,
      required: true
    }
  },
  data () {
    return {
      campaignBatteries: [],
      selected: '',
      showPowerBIReport: false
    }
  },
  methods: {
    ...mapActions({ setCurrentTeam: 'TEAMANALYTICS/setCurrentTeam' })
  },
  computed: {
    ...mapGetters({
      currentTeam: 'TEAMANALYTICS/getCurrentTeam'
    }),

    showQuestionnaireBtn () {
      return (this.currentTeam && this.currentTeam.QuestionnaireBatteries) ? this.currentTeam.QuestionnaireBatteries.length > 0 : false
    }
  }
}
</script>

<style>

</style>
